export enum PaginationKeys {
  Show = 'pagination_show_label',
  First = 'pagination_first_label',
  Last = 'pagination_last_label',
  Info = 'pagination_info_label',
}